export default class DateTime { 
    /**
     * @description Add month to date
     * @param {*} date
     * @param {*} months
     * @returns {string}
     */
    addMonths(date, months) {
        var d = date.getDate();
        date.setMonth(date.getMonth() + months);

        if (date.getDate() != d) {
            date.setDate(0);
        }

        return date.toLocaleString('sv-SE').slice(0, 10);
    }
}